module.exports = __webpack_public_path__ + "media/images/logo/sns/x-1d117cd539dd1757167ac23ac5c91027.png";